import * as Sentry from '@sentry/browser';

/**
 * Adds a Sentry breadcrumb scoped under the `readium.*` category namespace.
 * @param {string} category - sub-category appended to `readium.`
 * @param {string} message - short event identifier
 * @param {Object} [data] - non-PII context fields
 * @param {'info'|'warning'|'error'} [level]
 */
export function sendBreadcrumb(category, message, data = {}, level = 'info') {
    Sentry.addBreadcrumb({
        category: `readium.${category}`,
        message,
        level,
        data,
    });
}
